/**
 * API do procedimento de emergência de um perigo: `GET|PUT /occupational-risks/:id/emergency-procedure`.
 */
import apiClient from './apiClient';
import type { ProcedimentoDeEmergencia } from '../types/riskEmergencyProcedure';

class RiskEmergencyProcedureService {
  private baseUrl(riskId: number | string): string {
    return `/occupational-risks/${riskId}/emergency-procedure`;
  }

  async get(riskId: number | string): Promise<ProcedimentoDeEmergencia> {
    const response = await apiClient.get(this.baseUrl(riskId));
    return response.data as ProcedimentoDeEmergencia;
  }

  async save(
    riskId: number | string,
    procedimento: ProcedimentoDeEmergencia
  ): Promise<ProcedimentoDeEmergencia> {
    const response = await apiClient.put(this.baseUrl(riskId), procedimento);
    return response.data as ProcedimentoDeEmergencia;
  }
}

export const riskEmergencyProcedureService = new RiskEmergencyProcedureService();
export default riskEmergencyProcedureService;
